// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}

.menu {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  height: 50px;
}
.menu .text {
  margin: 0 7px;
}
.menu .arrow {
  transition-duration: 0.4s;
  transition-property: transform;
}
.menu .arrow.down {
  transform: rotate(-180deg);
}

.content {
  position: absolute;
  top: 50px;
  right: 0;
  width: 276px;
  z-index: 15;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  background-color: rgba(var(--ion-color-white-rgb), 0.62);
  border-radius: 10px;
  padding: 6.5px;
  padding-left: 5.5px;
}
.content .inner-content {
  width: 100%;
  background: var(--ion-color-white);
  border-radius: 5px;
  padding: 0 10px;
}
.content .inner-content ion-item {
  --padding-start: 0px;
  --inner-border-width: 0px 0px 0px 0px;
  --border-color: var(--ion-color-lines);
  --inner-padding-top: 0px;
  --inner-padding-bottom: 0px;
  --inner-padding-start: 7px;
  --inner-padding-end: 8px;
  --background-activated: var(--ion-color-background);
  --detail-icon-color: var(--ion-color-medium);
  --background-activated-opacity: 1;
}
.content .inner-content ion-item ion-img {
  margin-right: 9px;
  width: 30px;
}
.content .inner-content ion-item:first-child ion-img {
  width: 22px;
  height: 22px;
  margin-right: 17px;
}
.content .inner-content ion-item.last {
  --inner-border-width: 0px 0px 1px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header-profile-menu/header-profile-menu.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;AACJ;AAGE;EACI,yBAAA;EACA,8BAAA;AADN;AAGM;EACE,0BAAA;AADR;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EAEA,kCAAA;EACA,0BAAA;EACA,wDAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAJF;AAME;EACE,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAOI;EACE,oBAAA;EACA,qCAAA;EACA,sCAAA;EACA,wBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,mDAAA;EACA,4CAAA;EACA,iCAAA;AALN;AAOM;EACE,iBAAA;EACA,WAAA;AALR;AAQM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AANR;AASM;EACE,qCAAA;AAPR","sourcesContent":[":host {\n  position: relative;\n}\n\n.menu {\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  height: 50px;\n\n  .text {\n    margin: 0 7px;\n  }\n\n\n  .arrow {\n      transition-duration: 0.4s;\n      transition-property: transform;\n\n      &.down {\n        transform: rotate(-180deg);\n      }\n  }\n}\n\n.content{\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: 276px;\n  z-index: 15;\n\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px);\n  background-color: rgba(var(--ion-color-white-rgb), 0.62);\n  border-radius: 10px;\n  padding: 6.5px;\n  padding-left: 5.5px;\n\n  .inner-content {\n    width: 100%;\n    background: var(--ion-color-white);\n    border-radius: 5px;\n    padding: 0 10px;\n\n\n    ion-item {\n      --padding-start: 0px;\n      --inner-border-width: 0px 0px 0px 0px;\n      --border-color: var(--ion-color-lines);\n      --inner-padding-top:  0px;\n      --inner-padding-bottom: 0px;\n      --inner-padding-start: 7px;\n      --inner-padding-end: 8px;\n      --background-activated: var(--ion-color-background);\n      --detail-icon-color: var(--ion-color-medium);\n      --background-activated-opacity: 1;\n\n      ion-img {\n        margin-right: 9px;\n        width: 30px;\n      }\n\n      &:first-child ion-img {\n        width: 22px;\n        height: 22px;\n        margin-right: 17px;\n      }\n\n      &.last {\n        --inner-border-width: 0px 0px 1px 0px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
